// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"510":"tournament","962":"home"}[chunkId] + "." + {"510":"c7b508e4","962":"1d709c0b"}[chunkId] + ".css";
};